import React, { useEffect, useState } from "react";
import api from "../lib/api";
import Hero from "../components/sections/Hero";
import About from "../components/sections/About";
import Experience from "../components/sections/Experience";
import Education from "../components/sections/Education";
import Projects from "../components/sections/Projects";
import Skills from "../components/sections/Skills";
import Certifications from "../components/sections/Certifications";
import Testimonials from "../components/sections/Testimonials";
import Contact from "../components/sections/Contact";
import BlogTeaser from "../components/sections/BlogTeaser";
import Achievements from "../components/sections/Achievements";

export default function HomePage() {
  const [data, setData] = useState({
    profile: {}, experience: [], projects: [], skills: [],
    certifications: [], education: [], testimonials: [], blog: [], achievements: []
  });
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    (async () => {
      try {
        const [p, e, ed, pr, sk, c, t, b, a] = await Promise.all([
          api.get("/profile").catch(() => ({ data: {} })),
          api.get("/experience").catch(() => ({ data: [] })),
          api.get("/education").catch(() => ({ data: [] })),
          api.get("/projects").catch(() => ({ data: [] })),
          api.get("/skills").catch(() => ({ data: [] })),
          api.get("/certifications").catch(() => ({ data: [] })),
          api.get("/testimonials").catch(() => ({ data: [] })),
          api.get("/blog").catch(() => ({ data: [] })),
          api.get("/achievements").catch(() => ({ data: [] }))
        ]);
        setData({
          profile: p.data || {},
          experience: e.data || [],
          education: ed.data || [],
          projects: pr.data || [],
          skills: sk.data || [],
          certifications: c.data || [],
          testimonials: t.data || [],
          blog: b.data || [],
          achievements: a.data || []
        });
      } finally {
        setLoading(false);
      }
    })();
  }, []);

  return (
    <div data-testid="home-page">
      <Hero profile={data.profile} loading={loading} />
      <About profile={data.profile} />
      <Experience items={data.experience} />
      <Education items={data.education} />
      <Skills items={data.skills} />
      <Projects items={data.projects} />
      <Certifications items={data.certifications} />
      <Achievements items={data.achievements} />
      <BlogTeaser items={data.blog} />
      <Testimonials items={data.testimonials} />
      <Contact profile={data.profile} />
    </div>
  );
}

